<script setup lang="ts">
import camelCase from "lodash/camelCase";
import type { ProductDetails } from "mws-ts-v2-sdk";

type Props = {
  details: Record<string, string> | null;
  product: ProductDetails;
};

const { product, details } = defineProps<Props>();

const i18n = useI18n();

const detailsText = computed(() => {
  return Object.entries(details || {}).map(([key, value]) => {
    const localeKey = `product.description.${
      key === "Bio" ? "playerInfo" : camelCase(key)
    }`;

    return [translateWithFallback(i18n, localeKey, key), value];
  });
});

const { productTabViewed } = useAnalytics();
const onShowMore = () => {
  productTabViewed({
    tab_name: "Product Details",
    event_name: product.eventName ?? undefined,
    product_name: product.name,
  });
};
</script>

<template>
  <ProductDescriptionDrawerBase
    :is-collapsable="detailsText.length > 4"
    @show-more="onShowMore"
  >
    <template #content="{ isCollapsed }">
      <div class="flex flex-col gap-y-4">
        <div
          v-for="[label, value] in isCollapsed
            ? detailsText
            : detailsText.slice(0, 4)"
          :key="label"
          class="flex gap-12"
        >
          <div
            class="flex-1 md:flex-2 uppercase text-platform-text-2 font-bold"
          >
            {{ label }}
          </div>
          <pre class="flex-1 grow text-wrap">{{ value }}</pre>
        </div>
      </div>
    </template>
  </ProductDescriptionDrawerBase>
</template>
